import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormFieldBase, FormFieldType } from 'src/app/common/components/dynamic-form-field/components/dynamic-form-light/models/form-field-base';
import { MetadatoDocumento, questionsBasic, UploadFormConfiguration } from 'src/app/common/form/documento/document-uploaded/campi';
import { DetailTableComponent } from 'src/app/common/form/documento/document-uploaded/detail-table/detail-table.component';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { UploadDocumentUtilityService } from 'src/app/common/form/documento/document-uploaded/upload-document-utility.service';
import { QuestionControlService } from 'src/app/core/components/dynamic-form/services/question-control.service';
import { QuestionBase } from 'src/app/core/components/dynamic-form/models/question-base';
import { mapBooleanToString, mapToValue } from '../utils-remap';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-metadato-documento-form',
  templateUrl: './metadato-documento-form.component.html',
  styleUrls: ['./metadato-documento-form.component.css']
})
export class MetadatoDocumentoFormComponent implements OnInit, AfterViewInit {
  @Input() documento: DocumentoAllegato;
  @Input() isProtocol = false;
  @Input() disabled = false;
  modificaMetadatiDocumentoForm: FormGroup;
  dynamicFields: FormFieldBase[] = [];
  uploadConfig: UploadFormConfiguration = null;
  uniqueSubscription: Subscription;
  // metadataDocumento: MetadatoDocumento = null;
  documentiScansionati = [];
  @Output() onFormDataChanges = new EventEmitter();
  @ViewChild('detailTable') detailTable: DetailTableComponent;
  constructor(
    private fb: FormBuilder,
    private qcs: QuestionControlService,
    private utilityService: UploadDocumentUtilityService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.uploadConfig = this.utilityService.getConfigurationEdit(this.documento, this.isProtocol);
    this.dynamicFields = questionsBasic(this.uploadConfig.fields, this.dynamicFields);
    this.dynamicFields.forEach(el => {
      el.value = this.handleValue(el);
    })
    this.checkDocumentoUnico();
    this.modificaMetadatiDocumentoForm = this.qcs.toFormGroup(this.dynamicFields as QuestionBase[]);
    if (this.disabled) {
      this.modificaMetadatiDocumentoForm.disable();
    }
    const metadati = this.documento?.metadatoDocumento;
    // console.log(this.documento, 'this.documento')
    // console.log(this.uploadConfig, 'this.uploadConfig')
    // if(metadati?.tipoUfficioProduttore?.id === "INTERNO" && this.uploadConfig.name !== "notSigned") {
    //   const modalitaCtrl = this.modificaMetadatiDocumentoForm.get('modalitaFormazioneDocumento');
    //   modalitaCtrl?.setValue('A');
    //   if(this.uploadConfig.name !== "archive") modalitaCtrl?.disable();
    // };
    this.detectFormChanges();
    this.detectTipoUfficioProduttoreChanges();
    this.detectModeFormazioneFieldChanges();
    this.detectUniqueDocumentFieldChanges();
  }

  ngAfterViewInit(): void {
    const metadati = this.documento.metadatoDocumento;
      if (metadati?.documentiScansionati && metadati?.documentiScansionati.length > 0) {
        metadati.documentiScansionati.forEach(x => {
          this.detailTable.createRowWithData(x.titolo, x.produttore, x.firmatari);
        })
      }
  }

  private checkDocumentoUnico() {
    let metadato: MetadatoDocumento = { ...this.documento.metadatoDocumento };
    if(!("documentoUnico" in metadato)) return;
    if (metadato.documentoUnico === false && metadato.numDocumentiScansione >= 0) {
      this.dynamicFields.push(
        {
          id: "documentoUnico_" + this.documento.refDocumentale,
          controlType: FormFieldType[FormFieldType.RADIO],
          key: "documentoUnico",
          label: "Documento Unico",
          chips: false,
          options: [
            { id: "1_si", label: "Sì", value: "Sì" },
            { id: "2_no", label: "No", value: "No" },
          ],
          // value: true,
          disabled: false,
          required: false,
          value: mapBooleanToString(metadato.documentoUnico),
          size: "col-sm-2"
        }
      );
      this.dynamicFields.push({
        key: 'numDocumentiScansione',
        label: 'Numero copie scansione',
        controlType: 'number',
        size: 'col-sm-5',
        required: false,
        chips: false,
        options: null,
        value: metadato.numDocumentiScansione,
        disabled: false
      });
    } else if(metadato.documentoUnico === true){
       this.dynamicFields.push(
        {
          id: "documentoUnico_" + this.documento.refDocumentale,
          controlType: FormFieldType[FormFieldType.RADIO],
          key: "documentoUnico",
          label: "Documento Unico",
          chips: false,
          options: [
            { id: "1_si", label: "Sì", value: "Sì" },
            { id: "2_no", label: "No", value: "No" },
          ],
          // value: true,
          disabled: false,
          required: false,
          value: mapBooleanToString(metadato.documentoUnico),
          size: "col-sm-2"
        }
      );
    }
  }

  private handleValue(el: FormFieldBase): any {
    let metadato: any = { ...(this.documento?.metadatoDocumento || {}) };
    metadato.documentoUnico = mapBooleanToString(metadato.documentoUnico);
    metadato.modalitaFormazioneDocumento = mapToValue(metadato.modalitaFormazioneDocumento);
    metadato.motivoAssenzaFirma = mapToValue(metadato.motivoAssenzaFirma);
    metadato.tipoUfficioProduttore = mapToValue(metadato.tipoUfficioProduttore);
    return metadato[el.key];
  }

  private detectTipoUfficioProduttoreChanges() {
    const produttoreCtrl = this.modificaMetadatiDocumentoForm.get('tipoUfficioProduttore');
    if(this.uploadConfig.name === "notSigned") return;
    produttoreCtrl?.valueChanges.subscribe(value => {
    let modalitaCtrl = this.modificaMetadatiDocumentoForm.get('modalitaFormazioneDocumento');
      if (!modalitaCtrl) {
        this.modificaMetadatiDocumentoForm.addControl(
          'modalitaFormazioneDocumento',
          new FormControl(null)
        );
        modalitaCtrl = this.modificaMetadatiDocumentoForm.get('modalitaFormazioneDocumento');
      }
      let hasSign:boolean = 
        this.uploadConfig.name === "signed" || 
        this.uploadConfig.name === "signedNotValid" || 
        this.uploadConfig.name === "signedNotValidProtocol";
      // if (value === 'INTERNO') {
      //   modalitaCtrl.setValue('A', { emitEvent: true });
      //   modalitaCtrl.updateValueAndValidity();
      //   if(hasSign) modalitaCtrl.disable();
      // } else {
      //   modalitaCtrl.setValue('B', { emitEvent: true });
      //   modalitaCtrl.updateValueAndValidity();

      //   if(hasSign) modalitaCtrl.enable();
      // }
    });
  }


  private detectFormChanges() {
    this.modificaMetadatiDocumentoForm.valueChanges.subscribe(() => {
      let payload = this.modificaMetadatiDocumentoForm.getRawValue();
      payload.documentiScansionati = this.documentiScansionati;
      this.detailTable.addRow(payload.numDocumentiScansione);
      this.onFormDataChanges.emit(payload);
    });
  }

  onDetaillengthChange(length: number) {
    this.modificaMetadatiDocumentoForm.controls["numDocumentiScansione"].setValue(length);
  }

  onDetailChange(event) {
    this.documentiScansionati = event;
    let formData = this.modificaMetadatiDocumentoForm.getRawValue();
    formData.documentiScansionati = event;
    this.onFormDataChanges.emit(formData);
  };


  private detectModeFormazioneFieldChanges() {
    this.modificaMetadatiDocumentoForm.get("modalitaFormazioneDocumento")?.valueChanges.subscribe((value: string) => {
      if (this.uploadConfig.hasSign || this.uploadConfig.name.toLowerCase() === "archive") return;
      if (value === 'B') {
        let index = this.dynamicFields.findIndex(x => x.key === "documentoUnico");
        // listens to unique documents field changes
        if (index === -1) {
          this.dynamicFields.push(
            {
              id: "documentoUnico_" + this.documento.refDocumentale,
              controlType: FormFieldType[FormFieldType.RADIO],
              key: "documentoUnico",
              label: "Documento Unico",
              chips: false,
              options: [
                { id: "1_si", label: "Sì", value: "Sì" },
                { id: "2_no", label: "No", value: "No" },
              ],
              // value: true,
              disabled: false,
              required: false,
              size: "col-sm-2"
            }
          );
          this.modificaMetadatiDocumentoForm.addControl('documentoUnico', new FormControl("Sì"));
          this.detectUniqueDocumentFieldChanges();
        }
      } else {
        let indexUnique = this.dynamicFields.findIndex(x => x.key === "documentoUnico");
        if (indexUnique > -1) {
          this.dynamicFields.splice(indexUnique, 1);
          this.modificaMetadatiDocumentoForm.removeControl('documentoUnico');
        }
        let indexNumCopie = this.dynamicFields.findIndex(x => x.key === "numDocumentiScansione");
        if (indexNumCopie > -1) {
          this.dynamicFields.splice(indexNumCopie, 1);
          this.modificaMetadatiDocumentoForm.removeControl('numDocumentiScansione');
        }
        this.documentiScansionati = [];
        this.detailTable.rows.clear();
      }
      this.cdr.detectChanges();
    })
  }

  private detectUniqueDocumentFieldChanges() {
    if(!this.modificaMetadatiDocumentoForm.get('documentoUnico')) return;
    this.uniqueSubscription = this.modificaMetadatiDocumentoForm.get('documentoUnico').valueChanges.subscribe(value => {
      if (value.toLowerCase() === "no") {
        let index = this.dynamicFields.findIndex(x => x.key === "numDocumentiScansione");
        if (index === -1) {
          // this.canAddDetail = true;
          this.dynamicFields.push(
            {
              id: "numDocumentiScansione_" + this.documento.refDocumentale,
              controlType: FormFieldType[FormFieldType.NUMBER],
              key: "numDocumentiScansione",
              label: "Numero copie scansione",
              chips: false,
              // value: true,
              disabled: false,
              required: false,
              size: "col-sm-5"
            }
          );
          this.modificaMetadatiDocumentoForm.addControl('numDocumentiScansione', new FormControl(0), {emitEvent:false});
        }
      } else {
        let index = this.dynamicFields.findIndex(x => x.key === "numDocumentiScansione");
        if (index > -1) {
          this.dynamicFields.splice(index, 1);
          this.modificaMetadatiDocumentoForm.removeControl('numDocumentiScansione', {emitEvent: false});
        }
        this.documentiScansionati = [];
        this.detailTable.rows.clear();
        // this.payload = this.payload || {};
        // this.payload.documentiScansionati = [];
        // this.canAddDetail = false;
      }
      this.cdr.detectChanges();
    });
  }

  resetForm() {
    this.dynamicFields.forEach(field => {
      field.value = this.handleValue(field);
    });
    const initialValues = {};
    this.dynamicFields.forEach(field => {
      initialValues[field.key] = field.value ?? null;
    });

    this.modificaMetadatiDocumentoForm.reset(initialValues);
    this.documentiScansionati =
      this.documento.metadatoDocumento?.documentiScansionati
        ? JSON.parse(JSON.stringify(this.documento.metadatoDocumento.documentiScansionati))
        : [];

    this.detailTable?.rows.clear();

    if (this.documentiScansionati.length > 0) {
      this.documentiScansionati.forEach(x => {
        this.detailTable.createRowWithData(x.titolo, x.produttore, x.firmatari);
      });
    }
    let formData = this.modificaMetadatiDocumentoForm.getRawValue();
    formData.documentiScansionati = this.documentiScansionati;
    this.onFormDataChanges.emit(formData);
  }



}
